module.exports = __webpack_public_path__ + "img/home-os.1788978f.png";